import { j as r } from "../../../_virtual/jsx-runtime.js";
import i from "../../atoms/BaseCard/index.js";
import d from "../../atoms/BaseCardHeader/index.js";
import l from "../../atoms/charts/HistogramChart/index.js";
import p from "../../atoms/Icon/index.js";
import { cn as c } from "../../../lib/utils.js";
const u = ({
  title: s,
  iconProps: m,
  className: t,
  histogramChartProps: a,
  isLoading: e,
  children: o
}) => /* @__PURE__ */ r.jsxs(i, { className: c("w-full border border-gray-200 p-0", t), children: [
  /* @__PURE__ */ r.jsx(
    d,
    {
      title: s,
      titleClassName: "text-sm font-medium",
      className: "p-3",
      isLoading: e,
      children: /* @__PURE__ */ r.jsx(p, { height: 20, width: 20, ...m })
    }
  ),
  /* @__PURE__ */ r.jsx("div", { className: "-mb-3", children: /* @__PURE__ */ r.jsx(l, { ...a, children: o }) })
] });
export {
  u as default
};
